import { useState, useEffect, useRef } from 'react';
import { Toaster } from 'react-hot-toast';
import 'styles/DeviceManagement.css';
import { showAlert } from 'services/alerts.service';
import { makeRequest } from 'services/request.service';
import DevicesGroupsManagement from './DevicesGroupsManagement';
import DevicesManagement from './DevicesManagement';
import SectionIntro from 'components/common/SectionIntro';
import { useAuth } from 'auth/AuthContext';
import { useTranslation } from 'react-i18next';

const DeviceManagement = () => {
  const { t } = useTranslation();
  const hasFetched = useRef(false);
  const { user } = useAuth();

  const [state, setState] = useState({
    devices: [],
    devicesGroups: []
  });

  // Helper for auth headers
  const getAuthHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem('secret')}`,
    'Content-Type': 'application/json'
  });

  // get devices endpoint
  const getDevices = async () => {
    try {
      const response = await makeRequest({
        method: 'GET',
        url: `/management/devices/${user.farmId}`,
        headers: getAuthHeaders()
      });
      if (response.status === 200) {
        setState(s => ({ ...s, devices: response.data }));
      }
    } catch (error) {
      console.error('Error fetching devices:', error);
      showAlert({ message: t('devices.failedToFetchDevices'), icon: 'error' });
    }
  };

  // get devices groups
  const getDevicesGroups = async () => {
    try {
      const response = await makeRequest({
        method: 'GET',
        url: `/management/devices/groups/${user.farmId}`,
        headers: getAuthHeaders()
      });

      if (response.status === 200) {
        setState(s => ({ ...s, devicesGroups: response.data }));
      }
    } catch (error) {
      console.error('Error fetching device groups:', error);
      showAlert({ message: t('devices.failedToFetchDeviceGroups'), icon: 'error' });
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    getDevices();
    getDevicesGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen p-6 text-slate-100">
      <Toaster position="top-right" />

      <SectionIntro
        kicker={t('pageIntro.managementKicker')}
        title={t('nav.devices')}
        description={t('pageIntro.devicesDescription')}
      />

      <hr className="workspace-summary-divider my-5 border-t" />

      {/* Devices in Groups Management Section */}
      <DevicesGroupsManagement
        devices={state.devices}
        devicesGroups={state.devicesGroups}
        onRefreshDevices={getDevices}
        onRefreshDevicesGroups={getDevicesGroups}
        user={user}
      />

      {/* Device Groups Management Section */}
      <DevicesManagement
        devicesGroups={state.devicesGroups}
        onRefreshDevicesGroups={getDevicesGroups}
        user={user}
      />
    </div>
  );
};

export default DeviceManagement;
